<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchAppVersions } from "./api";

const router = useRouter();
const columns = [
  { key: "name",                    label: "Name",                    sortable: true },
  { key: "min_ios_version",         label: "Min iOS Version" },
  { key: "current_ios_version",     label: "Current iOS Version" },
  { key: "min_android_version",     label: "Min Android Version" },
  { key: "current_android_version", label: "Current Android Version" },
  { key: "actions",                 label: "Actions", align: "end", width: "120px" },
];
const { rows, loading, error, load } =
  useResourceList({
    fetch: fetchAppVersions,
    mapRow: (v) => ({
      id: v._id,
      name: v.name,
      min_ios_version: v.min_ios_version,
      current_ios_version: v.current_ios_version,
      min_android_version: v.min_android_version,
      current_android_version: v.current_android_version,
    }),
  });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">App Versions</h1>
      <VBtn variant="tonal" @click="load">Refresh</VBtn>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search versions…" empty-text="No versions found.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'app-versions-edit', params: { id: row.id } })">Edit</VBtn>
      </template>
    </AppDataTable>
  </section>
</template>
